/** Etiquetas de la escala 0–6 del test 4 Creatividades */
export const ESCALA_RESPUESTA = [
  "Nada",
  "Muy poco",
  "Poco",
  "Moderadamente",
  "Bastante",
  "Mucho",
  "Siempre",
];

export function etiquetaEscala(valor, t) {
  if (typeof t === "function") {
    return t(`scale.${valor}`);
  }
  return ESCALA_RESPUESTA[valor] ?? "";
}
